import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class TimeToolService extends BaseService {

	constructor() {	
		super();
	}
	
	async getDataSync(tractorId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/time-tools/tractors/' + tractorId + params);		
		return data;		
	}
	
	async timezone(request) {	
		var result = await this.makePOSTRequest('/api/resource/time-tools/timezone', request);
		return result;
	}	
	
	async applyTimeshift(timeShiftRequest) {	
		var result = await this.makePUTRequest('/api/resource/time-tools/apply-shifts', timeShiftRequest);
		return result;
	}		
	
}



